import InformationCard from './InformationCard';

const Information = ({ paymentKind, cardMessage }) => {
  if (paymentKind === 'saved-cards')
    return (
      <InformationCard
        icon="illustration-card-pay"
        title={cardMessage || 'Tap or insert your card on the reader!'}
        description="You can also use a saved card or enter your card details manually."
      />
    );

  return (
    <InformationCard
      icon="illustration-credit-card"
      title="Enter your card details"
      description="You can also tap or insert your card on the reader or use a saved card."
    />
  );
};

export default Information;
